/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Minimization_TextInputs */

const en_privacy_minimization_text = /** @type {(inputs: Privacy_Minimization_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We collect only the personal data that is necessary to provide our services. We do not collect or retain data beyond what is required for the specified purposes.`)
};

const de_privacy_minimization_text = /** @type {(inputs: Privacy_Minimization_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir erheben nur die personenbezogenen Daten, die fuer die Erbringung unserer Dienste erforderlich sind. Wir erheben oder speichern keine Daten ueber das fuer die angegebenen Zwecke erforderliche Mass hinaus.`)
};

const fr_privacy_minimization_text = /** @type {(inputs: Privacy_Minimization_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous ne collectons que les données personnelles nécessaires à la fourniture de nos services. Nous ne collectons ni ne conservons de données au-delà de ce qui est requis pour les finalités spécifiées.`)
};

const es_privacy_minimization_text = /** @type {(inputs: Privacy_Minimization_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo recopilamos los datos personales necesarios para prestar nuestros servicios. No recopilamos ni conservamos datos más allá de lo necesario para las finalidades especificadas.`)
};

const it_privacy_minimization_text = /** @type {(inputs: Privacy_Minimization_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raccogliamo solo i dati personali necessari per fornire i nostri servizi. Non raccogliamo né conserviamo dati oltre quanto richiesto per le finalità specificate.`)
};

const nl_privacy_minimization_text = /** @type {(inputs: Privacy_Minimization_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wij verzamelen alleen de persoonsgegevens die noodzakelijk zijn voor het leveren van onze diensten. Wij verzamelen of bewaren geen gegevens die niet vereist zijn voor de gespecificeerde doeleinden.`)
};

const pl_privacy_minimization_text = /** @type {(inputs: Privacy_Minimization_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zbieramy wyłącznie dane osobowe niezbędne do świadczenia naszych usług. Nie zbieramy ani nie przechowujemy danych wykraczających poza to, co jest wymagane do określonych celów.`)
};

const fi_privacy_minimization_text = /** @type {(inputs: Privacy_Minimization_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keräämme vain henkilötietoja, jotka ovat välttämättömiä palveluidemme tarjoamiseksi. Emme kerää tai säilytä tietoja enempää kuin määritellyt tarkoitukset edellyttävät.`)
};

const da_privacy_minimization_text = /** @type {(inputs: Privacy_Minimization_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi indsamler kun de persondata, der er nødvendige for at levere vores tjenester. Vi indsamler eller opbevarer ikke data ud over, hvad der kræves til de angivne formål.`)
};

const sv_privacy_minimization_text = /** @type {(inputs: Privacy_Minimization_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi samlar bara in de personuppgifter som är nödvändiga för att tillhandahålla våra tjänster. Vi samlar inte in eller lagrar data utöver vad som krävs för de angivna ändamålen.`)
};

/**
* | output |
* | --- |
* | "We collect only the personal data that is necessary to provide our services. We do not collect or retain data beyond what is required for the specified purpo..." |
*
* @param {Privacy_Minimization_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_minimization_text = /** @type {((inputs?: Privacy_Minimization_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Minimization_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_minimization_text(inputs)
	if (locale === "fr") return fr_privacy_minimization_text(inputs)
	if (locale === "es") return es_privacy_minimization_text(inputs)
	if (locale === "it") return it_privacy_minimization_text(inputs)
	if (locale === "nl") return nl_privacy_minimization_text(inputs)
	if (locale === "pl") return pl_privacy_minimization_text(inputs)
	if (locale === "fi") return fi_privacy_minimization_text(inputs)
	if (locale === "da") return da_privacy_minimization_text(inputs)
	if (locale === "sv") return sv_privacy_minimization_text(inputs)
	return en_privacy_minimization_text(inputs)
});